import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _content, _right;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { breakpoints } from '~theme/breakpoints';
import * as mixins from '~utils/mixins';
export var container = {
  mt: 3,
  mb: 4,
  border: function border(t) {
    return "1px solid " + t.colors.border;
  },
  borderRadius: 'radius',
  overflow: 'hidden',
  bg: 'props.bg',
  color: 'props.text',
  fontSize: 3
};

if (typeof container !== 'undefined' && container && container === Object(container) && Object.isExtensible(container) && !container.hasOwnProperty('__filemeta')) {
  Object.defineProperty(container, '__filemeta', {
    configurable: true,
    value: {
      name: "container",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var content = (_content = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column'
}, _content["@media (min-width: " + breakpoints.tablet + "px)"] = {
  flexWrap: 'nowrap',
  flexDirection: 'row'
}, _content);

if (typeof content !== 'undefined' && content && content === Object(content) && Object.isExtensible(content) && !content.hasOwnProperty('__filemeta')) {
  Object.defineProperty(content, '__filemeta', {
    configurable: true,
    value: {
      name: "content",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var line = {
  pt: 2,
  '& + &': {
    borderTop: function borderTop(t) {
      return "1px solid " + t.colors.border;
    }
  }
};

if (typeof line !== 'undefined' && line && line === Object(line) && Object.isExtensible(line) && !line.hasOwnProperty('__filemeta')) {
  Object.defineProperty(line, '__filemeta', {
    configurable: true,
    value: {
      name: "line",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

var column = {
  minWidth: 0,
  pb: 2,
  px: 3,
  '& ~ &': {
    bg: 'red'
  }
};
export var propName = _objectSpread(_objectSpread({}, column), {}, {
  color: 'props.highlight'
});

if (typeof propName !== 'undefined' && propName && propName === Object(propName) && Object.isExtensible(propName) && !propName.hasOwnProperty('__filemeta')) {
  Object.defineProperty(propName, '__filemeta', {
    configurable: true,
    value: {
      name: "propName",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var propType = _objectSpread(_objectSpread({}, column), {}, {
  color: 'props.text'
});

if (typeof propType !== 'undefined' && propType && propType === Object(propType) && Object.isExtensible(propType) && !propType.hasOwnProperty('__filemeta')) {
  Object.defineProperty(propType, '__filemeta', {
    configurable: true,
    value: {
      name: "propType",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var defaultValue = _objectSpread(_objectSpread({}, column), {}, {
  color: 'props.defaultValue'
});

if (typeof defaultValue !== 'undefined' && defaultValue && defaultValue === Object(defaultValue) && Object.isExtensible(defaultValue) && !defaultValue.hasOwnProperty('__filemeta')) {
  Object.defineProperty(defaultValue, '__filemeta', {
    configurable: true,
    value: {
      name: "defaultValue",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var right = (_right = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  px: 3,
  flex: 1
}, _right["@media (max-width: " + breakpoints.tablet + "px)"] = {
  position: 'absolute',
  top: 0,
  right: 0
}, _right);

if (typeof right !== 'undefined' && right && right === Object(right) && Object.isExtensible(right) && !right.hasOwnProperty('__filemeta')) {
  Object.defineProperty(right, '__filemeta', {
    configurable: true,
    value: {
      name: "right",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var propRequired = {
  color: 'props.text',
  fontSize: 1,
  opacity: 0.5
};

if (typeof propRequired !== 'undefined' && propRequired && propRequired === Object(propRequired) && Object.isExtensible(propRequired) && !propRequired.hasOwnProperty('__filemeta')) {
  Object.defineProperty(propRequired, '__filemeta', {
    configurable: true,
    value: {
      name: "propRequired",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var openDescBtn = _objectSpread(_objectSpread({}, mixins.ghostButton), {}, {
  mt: 0,
  ml: 3,
  color: 'props.defaultValue'
});

if (typeof openDescBtn !== 'undefined' && openDescBtn && openDescBtn === Object(openDescBtn) && Object.isExtensible(openDescBtn) && !openDescBtn.hasOwnProperty('__filemeta')) {
  Object.defineProperty(openDescBtn, '__filemeta', {
    configurable: true,
    value: {
      name: "openDescBtn",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}

export var description = {
  fontSize: 2,
  m: 0,
  py: 2,
  px: 3,
  borderTop: function borderTop(t) {
    return "1px solid " + t.colors.border;
  },
  color: 'props.descriptionText',
  bg: 'props.descriptionBg'
};

if (typeof description !== 'undefined' && description && description === Object(description) && Object.isExtensible(description) && !description.hasOwnProperty('__filemeta')) {
  Object.defineProperty(description, '__filemeta', {
    configurable: true,
    value: {
      name: "description",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/styles.js"
    }
  });
}